import {Component, Host, h, Prop} from '@stencil/core';

@Component({
  tag: 'nest-select-option',
  styleUrl: 'nest-select-option.scss',
  shadow: true,
})
export class NestSelectOption {
  @Prop() label: string;
  @Prop() selected: boolean = false;

  render() {
    return (
      <Host>
        <div class="flex w-full items-center px-1 pt-1 border-transparent bg-background relative hover:cursor-pointer">
          <div class="text-accent-foreground hover:bg-accent w-full flex justify-between rounded p-2 items-center">
            <div class="mx-2 leading-6">{this.label}</div>
            {this.selected &&
              <nest-icon name='check-outline' class='w-3 h-3'></nest-icon>
            }
          </div>
        </div>
      </Host>
    );
  }

}
